export default {
  yes: "Yes",
  no: "No",

  info: "Info",

  next: "Next",
  back: "Back",

  "action.skip": "Skip",

  "action.login": "Login",
  "action.accept-terms-and-conditions":
    "I have read, understood and accept the {anbs}.",
  "action.accept-privacy": "I have read, understood and accept the {privacy}.",
  "action.send-again": "Send again",
  "action.login-and-continue": "Login and continue",
  "action.accept": "Accept",
  "action.decline": "Decline",
  "action.switch-back": "Switch back to own account",
  "action.delete": "Delete",
  "action.pause": "Pause",
  "action.forgot-password": "Password forgotten?",
  "action.reset-password": "Reset password",
  "action.cancel": "Cancel",
  "action.confirm": "Confirm",
  "action.logout": "Logout",
  "action.search": "Search",
  "action.open-in-maps": "Display location",
  "action.book-appointment": "Book appointment",
  "action.see-more-appointment-proposals": "Show more date suggestions",

  "action.show-qr-code": "Please show this code during the admission",

  "see-all": "Show all",
  "register-now": "Register now",
};
